import { render, staticRenderFns } from "./MobileSubmit.vue?vue&type=template&id=19ca2dfa"
import script from "./MobileSubmit.vue?vue&type=script&lang=js"
export * from "./MobileSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports